import { Expose } from "class-transformer";

export class RemoveWorksheetsFromCertificationDto {
  @Expose()
  certificationId: string;

  @Expose()
  worksheetIds: string[];
}
